import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'cmsConfig',
      'cmsAdConfig',
      'menus',
      'pinedMenus',
      'portalMenus',
      'businessName',
      'userInfo',
      'showHeatmap',
      'menuPath'
    ]),
    ...mapState('popHome',['winInfo'])
  },
  methods: {
    ...mapActions([
      'getCMSConfig',
      'getCMSAdConfig',
      'getMenus',
      'getMenusV2',
      'getPortalMenu',
      'logout',
      'setCurrentMenuPath'
    ])
  }
}
